export const ARAPAWA = 'arapawa';
export const BLOOD = 'blood';
export const COAL = 'coal';
export const CONCRETE = 'concrete';
export const CURIOUS_BLUE = 'curious-blue';
export const DENIM = 'denim';
export const GIGAS = 'gigas';
export const GRAY_120 = 'gray-120';
export const GRAY_20 = 'gray-20';
export const GRAY_40 = 'gray-40';
export const GRAY_60 = 'gray-60';
export const GRAY150 = 'gray150';
export const LAVENDER_ROSE = 'lavender-rose';
export const LOCHMARA = 'lochmara';
export const LOCHMARA_SHADOW = 'lochmara-shadow';
export const MINE_SHAFT = 'mine-shaft';
export const PURE_BLACK = 'pure-black';
export const PURE_WHITE = 'pure-white';
export const SILVER_CHALICE = 'silver-chalice';
export const TEXT_GOOD = 'text-good';
export const TOREA_BAY = 'torea-bay';
export const TREE_POPPY = 'tree-poppy';
export const YORK = 'york';

export default {
    [ARAPAWA]: '#09064a',
    [BLOOD]: '#bd2619',
    [COAL]: '#3c3c3c',
    [CONCRETE]: '#f2f2f2',
    [CURIOUS_BLUE]: '#27aae1',
    [DENIM]: '#108ccf',
    [GIGAS]: '#583f99',
    [GRAY_120]: '#787878',
    [GRAY_20]: '#f0f0f0',
    [GRAY_40]: '#e5e5e5',
    [GRAY_60]: '#b3b3b3',
    [GRAY150]: '#5a5a5a',
    [LAVENDER_ROSE]: '#fa79d8',
    [LOCHMARA]: '#008dd0',
    [LOCHMARA_SHADOW]: '#0072a9',
    [MINE_SHAFT]: '#444444',
    [PURE_BLACK]: '#000000',
    [PURE_WHITE]: '#ffffff',
    [SILVER_CHALICE]: '#999999',
    [TEXT_GOOD]: '#39b568',
    [TOREA_BAY]: '#102d7b',
    [TREE_POPPY]: '#f7941d',
    [YORK]: '#6ac17b',
}
